import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "title" }
const _hoisted_3 = ["aria-label"]
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "vp-navbar-dropdown" }
const _hoisted_6 = { class: "vp-navbar-dropdown-subtitle" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "vp-navbar-dropdown-subitem-wrapper" }

import VPAutoLink from '@theme/VPAutoLink.vue'
import VPDropdownTransition from '@theme/VPDropdownTransition.vue'
import { useToggle } from '@vueuse/core'
import { computed, toRefs, watch } from 'vue'
import { useRoute } from 'vuepress/client'
import type { AutoLinkOptions, NavGroup } from '../../shared/index.js'


export default /*@__PURE__*/_defineComponent({
  __name: 'VPNavbarDropdown',
  props: {
    config: {}
  },
  setup(__props: any) {

const props = __props

const { config } = toRefs(props)
const route = useRoute()

const [open, toggleOpen] = useToggle(false)

const dropdownAriaLabel = computed(
  () => config.value.ariaLabel || config.value.text,
)

const isLastItemOfArray = (arrayItem: unknown, array: unknown[]): boolean =>
  array[array.length - 1] === arrayItem

/**
 * Open the dropdown when user tab and click from keyboard.
 *
 * Use event.detail to detect tab and click from keyboard.
 * The Tab + Click is UIEvent > KeyboardEvent, so the detail is 0.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/UIEvent/detail
 */
const handleDropdown = (e: UIEvent): void => {
  if (e.detail === 0) toggleOpen()
  else toggleOpen(false)
}

watch(
  () => route.path,
  () => {
    toggleOpen(false)
  },
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["vp-navbar-dropdown-wrapper", { open: _unref(open) }])
  }, [
    _createElementVNode("button", {
      class: "vp-navbar-dropdown-title",
      type: "button",
      "aria-label": dropdownAriaLabel.value,
      onClick: handleDropdown
    }, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(config).text), 1),
      _cache[1] || (_cache[1] = _createElementVNode("span", { class: "arrow down" }, null, -1))
    ], 8, _hoisted_1),
    _createElementVNode("button", {
      class: "vp-navbar-dropdown-title-mobile",
      type: "button",
      "aria-label": dropdownAriaLabel.value,
      onClick: _cache[0] || (_cache[0] = () => _unref(toggleOpen)())
    }, [
      _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(config).text), 1),
      _createElementVNode("span", {
        class: _normalizeClass(["arrow", _unref(open) ? 'down' : 'right'])
      }, null, 2)
    ], 8, _hoisted_3),
    _createVNode(VPDropdownTransition, null, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("ul", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(config).children, (child) => {
            return (_openBlock(), _createElementBlock("li", {
              key: child.text,
              class: "vp-navbar-dropdown-item"
            }, [
              ('children' in child)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("h4", _hoisted_6, [
                      (child.link)
                        ? (_openBlock(), _createBlock(VPAutoLink, {
                            key: 0,
                            config: child,
                            onFocusout: 
                  () => {
                    if (
                      isLastItemOfArray(child, _unref(config).children) &&
                      child.children.length === 0
                    ) {
                      open.value = false
                    }
                  }
                
                          }, null, 8, ["config", "onFocusout"]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(child.text), 1))
                    ]),
                    _createElementVNode("ul", _hoisted_8, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(child.children, (grandchild) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: grandchild.link,
                          class: "vp-navbar-dropdown-subitem"
                        }, [
                          _createVNode(VPAutoLink, {
                            config: grandchild,
                            onFocusout: 
                    () => {
                      if (
                        isLastItemOfArray(grandchild, child.children) &&
                        isLastItemOfArray(child, _unref(config).children)
                      ) {
                        _unref(toggleOpen)(false)
                      }
                    }
                  
                          }, null, 8, ["config", "onFocusout"])
                        ]))
                      }), 128))
                    ])
                  ], 64))
                : (_openBlock(), _createBlock(VPAutoLink, {
                    key: 1,
                    config: child,
                    onFocusout: 
                () => {
                  if (isLastItemOfArray(child, _unref(config).children)) {
                    _unref(toggleOpen)(false)
                  }
                }
              
                  }, null, 8, ["config", "onFocusout"]))
            ]))
          }), 128))
        ], 512), [
          [_vShow, _unref(open)]
        ])
      ]),
      _: 1
    })
  ], 2))
}
}

})